import React, {useRef, useState} from 'react';
import emailjs from '@emailjs/browser';
import Page from './page';

function Contact() {

    const form = useRef<HTMLFormElement | null>(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const sendEmail = (e: any) => {
        e.preventDefault();
        setError('')
        setLoading(true)
        // @ts-ignore
        emailjs.sendForm(process.env.REACT_APP_EMAIL_SERVICE_ID, process.env.REACT_APP_EMAIL_TEMPLATE_ID, e.target, process.env.REACT_APP_EMAIL_PUBLIC_KEY)
            .then((result) => {
                setError("Your request was sent. Please expect a reply from us within 72hours")
                setLoading(false)
            }, (error) => {
                console.log("ds",error)
                setError("Oops, we couldn't send your message there. Please try again")
                setLoading(false)
            });
    };


    return (
        <Page
            label="Data — Request"
            title="Your data."
            intro="Request a copy of your historical data, or have your data or account deleted from our systems."
        >
            <form ref={form} onSubmit={sendEmail} className="max-w-[44rem] flex flex-col gap-12">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-12 sm:gap-8">
                    <div className="field">
                        <label htmlFor="user_name">Your name</label>
                        <input type="text" name="user_name" id="user_name" autoComplete="name" required />
                    </div>
                    <div className="field">
                        <label htmlFor="user_email">Your email</label>
                        <input type="email" name="user_email" id="user_email" autoComplete="email" required />
                    </div>
                </div>

                <div className="field">
                    <label htmlFor="company">Request type</label>
                    <select name="company" id="company">
                        <option value={'Account Deletion'}>Account Deletion</option>
                        <option value={'Data History Request'}>Data History Request</option>
                        <option value={'Data Deletion'}>Data Deletion</option>
                    </select>
                </div>

                <div className="field">
                    <label htmlFor="message">Message</label>
                    <textarea name="message" id="message" required></textarea>
                </div>

                <div className="flex flex-col sm:flex-row sm:items-center gap-6">
                    <button className="btn-line self-start" type="submit" disabled={loading}>
                        {loading ? "Sending…" : "Send request"}
                        <span aria-hidden="true">→</span>
                    </button>
                    {error && <p className="mono text-[#b3b0a9]" role="status">{error}</p>}
                </div>
            </form>
        </Page>
    );
}

export default Contact;
